import { Box, Typography, Button, Grid, Divider } from '@material-ui/core'
import { Fragment, useState, useRef, useEffect, useMemo } from 'react'
import extractPdf2Json from '../../lib/extractPdf2Json'
import convertFromMadrData from '../../lib/convertFromMadrData'
import {useLocation} from "react-router-dom"
import moment from 'moment'
import ImportedPresentationTpl from './ImportedPresentationTpl'
import CheckContact from './CheckContact'
import { useMutation } from '@apollo/client'
import { DOSAR_MUTATION, OFERTANT_MUTATION, PREEMPTOR_MUTATION } from '../../apollo/mutation'
import { useHistory } from 'react-router-dom'
import config from '../../config'


const { NAMESPACE } = config

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ImportCerere() {

    const [data, setData] = useState(null)
    const [jsonData, setJsonData] = useState(null)
    const [dragActive, setDragActive] = useState(false)
    const inputRef = useRef(null)
    const params = useQuery()
    const nr =  +params.get("nr")
    const dt = params.get("dt") || new Date()
     const [mutateDosar, _] = useMutation(DOSAR_MUTATION)
     const [mutatePreemptor] = useMutation(PREEMPTOR_MUTATION)
     const [mutateOfertant] = useMutation(OFERTANT_MUTATION)
     const [ls, setLs] = useState()
     const history = useHistory()



     useEffect(()=>{
        let lsItem = localStorage.getItem(NAMESPACE)
        if (lsItem) setLs(JSON.parse(lsItem))
     }, [])

    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFile(e.dataTransfer.files[0]);
        }
    };

    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            handleFile(e.target.files[0]);
        }
    };

    const onButtonClick = () => {
        inputRef.current.click();
    };

    const handleFile = (file) => {
        if (file.type !== "application/pdf") {
            alert("Vă rugăm să încărcați un fișier PDF.");
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            setData(e.target.result);
        };
        reader.readAsArrayBuffer(file);
    }

    useEffect(() => {
        if (data) {
            extractPdf2Json(data).then(
                r=>{ 
                    console.log("er (original):", r)
                    let conv = convertFromMadrData(r)
                    conv = {
                        nr:nr,
                        dt: dt, 
                        ...conv,
                        anexe: {
                            ...conv.anexe,
                            terenCat: conv?.anexe?.terenCategorie?.toLocaleUpperCase() || "n/a",
                        }
                    }
                    setJsonData(conv)
                },
                err => alert("nu am putut importa cererea")
            )
        }
    }, [data])

    const resetHandler = () => {
        setData(null)
        setJsonData(null)
    }

    const handleContact = (index, tip) => ev => {
        console.log("handle contact:", index, tip, ev)  
        let nd = {...jsonData}
        nd.ofertanti[index][tip] = ev
        setJsonData(nd)
    }

    const handelNotAllHaveIds = useMemo(() => {
        let count = 0
        count = jsonData?.ofertanti.reduce( (acc,el)=> {
            count=0
            if (!el.titular?.id) count++
            if (!el.mandatar?.id) count++ 
            return acc+count
        }, 0)
        return count>0
    }, [data])

  const handleSubmit = async () => {
        console.log("handler submit")
    const dosar = {...jsonData}

        let ofertanti = regId => dosar.ofertanti.map(el => ({
            id: el.id ? +el.id : 0,
            tip: true,
            titularId: +el?.titular?.id,
            mandatarId: +el?.mandatar?.id || 0,
            companyId: +ls.companyId,
            registruId: regId,
            calitate: el.calitate, prin: el.prin, conform: el.conform
        }))
        let preemptori = regId => dosar?.preemptori?.map(el => ({
            id: +el.id || 0,
            // id: (el.id && el.id !== 0) ? el.id : null,
            titularId: el?.titular?.id,
            mandatarId: el?.mandatar?.id,
            registruId: regId,
            rangPreemptorId: +el.rangPreemptorId,
            companyId: +ls.companyId
        }))
        let q = {
            tipDosar: dosar.tip,
            nr: +dosar.nr,
            dt: dosar.dt,
            status: "OPERARE",
            anexe: JSON.stringify(dosar.anexe),
            companyId: ls.companyId,
            userId: ls.id
        }
        let qDosar, qOfertanti=[], qPreemptori=[], result
        try {
         qDosar = await mutateDosar({ variables: { data: q } })
         if (qDosar) {
            qOfertanti = await ofertanti(qDosar.data.dosar.id).map(async el => await mutateOfertant({ variables: { data: el } }))
            if (dosar?.preemptori && dosar?.preemptori.length > 0) {
                qPreemptori = await preemptori(qDosar.data.dosar.id).map(async el => await mutatePreemptor({ variables: { data: el } }))
            }
           
        }
        
        result = await Promise.all([qDosar, ...qOfertanti, ...qPreemptori])
        } catch(err) {
            console.log("ERROR:", err)
            alert (err?.toString() || "A apărut o eroare!")
        }
        

        if (result) {
            
            // console.log("dosar id: ", qDosar?.data?.dosar?.id)
            history.push(`/dosar/${qDosar?.data?.dosar?.id}`)
        }
    }

    return (
        <Fragment>
            {console.log("LS:", ls)}
            <Typography variant='h4' align='center' style={{ fontWeight: 800, marginTop: "20px" }} color="primary">
                IMPORT CERERE DE AFIȘARE ȘI OFERTĂ DE VÂNZARE DIN PDF "INTELIJENT" - REGISTRUL MADR </Typography>
                                    <Box sx={{ width: "100%", py: 1, backgroundColor:"lightgrey" }}>
                        <Typography variant="h5" align="center" style = {{margin:0, padding:0}}>Cererea nr. {nr} din {moment(dt).format("DD.MM.YYYY")}</Typography>
                    </Box>
            {!data && (
                <Box>

                    <Typography variant="body1" align="center" component="p" style={{ lineHeight: 1, marginTop: "20px" }}>
                        Trageți fișierul PDF gata completat în chenarul de mai jos
                    </Typography><br />
                    <Typography variant="body2" component="p" color="secondary" align='center' style={{ lineHeight: 1 }}>
                        <strong>ATENȚIE!!!</strong> Nu funcționeazaă cu varianta scanată ci doar cu fișierul PDF inteligent, completat și salvat!
                    </Typography>
                    <Box
                        sx={{
                            margin: "1rem",
                            width: "auto",
                            height: "50vh",
                            marginRight:"10%", marginLeft: "10%",
                            border: dragActive ? "2px dashed green" : "2px solid navy",
                            backgroundColor: dragActive ? "rgba(0, 128, 0, 0.1)" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column"
                        }}
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                    >
                        <input ref={inputRef} type="file" accept="application/pdf" style={{ display: "none" }} onChange={handleChange} />
                        <Typography variant="h6" color="primary" style={{ marginBottom: "1rem" }}>
                            {data ? "Fișier încărcat!" : "Trageți fișierul aici sau"}
                        </Typography>
                        <Button variant="contained" color="primary" onClick={onButtonClick}>
                            ÎNCARCĂ PDF
                        </Button>
                    </Box>


                </Box>
            )}
            {data && (
                <Box sx={{ width: "100%" }}>
                    <div align="right" style = {{marginRight:"20px"}}>
                    <Button variant="contained" color="secondary" onClick={resetHandler}>
                        RESET
                    </Button>
                    </div>
                    <Grid container>
                        <Grid item xs ={3}>
                            <Typography variant="body1"
                                style = {{marginLeft:"30px", fontWeight:800, color:"darkred"}}
                                >DATE IMPORTATE</Typography>
                            <Box sx = {{border:"1px solid grey", p:2, m:2, height:"70vh", overflow:"auto"}}>
                                <small>
                            <pre>{JSON.stringify(jsonData, null, 3)}</pre>
                            </small>
                            </Box>
                        </Grid>
                        <Grid item xs={6} style={{  height: "77vh", overflow: "auto" }}>
                            <ImportedPresentationTpl data = {jsonData}/>
                        </Grid>
                        <Grid item xs ={3}>
                            <Box sx = {{
                                background: "#dcdcdc",
                                // width:"100%",
                                margin:20, padding:"2em",
                                height:"70vh"
                            }}>
                              VERIFICARI<br/>

                             Verificam daca persoanele titularii si mandatarii exista deja in agenda aplicatiie
                                {jsonData?.ofertanti?.map( (e,i) =>(
                                    <Fragment key ={i}>
                                    {e.titular && <><CheckContact contact = {e.titular} onChange = {handleContact(i, "titular")}/></>}
                                    {e.mandatar && <><CheckContact contact = {e.mandatar} onChange = {handleContact(i, "mandatar")}/></>}
                                    </Fragment>
                                ))}
                                <br/><br/>
                                <Divider/>
                                <br/><br/>
                                <Button 
                                    color="primary" 
                                    variant="contained" 
                                    disabled = {handelNotAllHaveIds}
                                    onClick = {handleSubmit}
                                    >
                                        CREAZA DOSARUL
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            )}
        </Fragment>
    )
}
